import {
  Avatar,
  Box,
  Button,
  IconButton,
  Menu,
  MenuItem,
  Typography,
  useMediaQuery,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MenuIcon from "@mui/icons-material/Menu";
import React from "react";
import "./Header.css";
import logo from "../../assets/logo.png";
import Grid from "@mui/material/Grid";
import { SignOutButton } from "../../common/commonStyles";
import patientImage from "../../assets/patient.png";
import Badge from "@mui/material/Badge";
import NotificationsNoneOutlinedIcon from "@mui/icons-material/NotificationsNoneOutlined";
import { useNavigate } from "react-router-dom";
import MessageIcon from "@mui/icons-material/Message";
import { logout } from "../../services/authservice";

const Header = (userDetail) => {
  const navigate = useNavigate();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const handleMenuOpen = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleMenuClose = () => {
    setAnchorEl(null);
  };

  const handleSignOut = () => {
    logout();
    navigate("/");
  };
  return (
        <Grid container className="header" alignItems="center">
          <Grid size={4}>
            <Box>
              <img
                src={logo}
                alt="Logo"
                style={{ height: 45, maxHeight: 45,cursor: "pointer" }}
                onClick={() => navigate("/dashboard")}
              />
            </Box>
          </Grid>
          {isMobile ? (
            <>
              <Grid size={8} display="flex" justifyContent="end">
                <IconButton
                  edge="end"
                  color="inherit"
                  aria-label="user menu"
                  onClick={handleMenuOpen}
                  size="large"
                >
                  <MenuIcon />
                </IconButton>
                <Menu
                  anchorEl={anchorEl}
                  open={open}
                  onClose={handleMenuClose}
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  transformOrigin={{ vertical: "top", horizontal: "right" }}
                >
                  <MenuItem>
                    <Avatar
                      src={patientImage}
                      sx={{ width: 32, height: 32, mr: 1 }}
                    />
                    <Typography variant="body1">
                      {userDetail?.userDetail?.name}
                    </Typography>
                  </MenuItem>
                  <MenuItem
                    onClick={() => {
                      handleMenuClose();
                      // Add your sign-out logic here
                    }}
                  >
                    <Button
                      variant="outlined"
                      size="small"
                      sx={SignOutButton}
                      fullWidth
                    >
                      Sign Out
                    </Button>
                  </MenuItem>
                </Menu>
              </Grid>
            </>
          ) : (
            <Grid size={8} display="flex" justifyContent="end">
              <Grid container spacing={2} display="flex" alignItems="center">
                <Grid size="auto">
                  <Badge color="secondary" variant="dot" invisible={false}>
                    <NotificationsNoneOutlinedIcon
                      className="header_icon"
                      onClick={handleMenuOpen}
                    />
                  </Badge>
                  <Menu
                    anchorEl={anchorEl}
                    open={open}
                    onClose={handleMenuClose}
                    disableScrollLock
                    keepMounted
                    PaperProps={{
                      elevation: 4,
                      sx: { borderRadius: 3, width: 300, p: 1 },
                    }}
                    anchorOrigin={{
                      vertical: "bottom",
                      horizontal: "right",
                    }}
                    transformOrigin={{
                      vertical: "top",
                      horizontal: "right",
                    }}
                  >
                    <Typography
                      variant="subtitle1"
                      sx={{
                        px: 1,
                        py: 1,
                        fontWeight: "bold",
                        fontFamily: "Nunito, sans-serif",
                        fontSize: 16,
                      }}
                    >
                      Notifications
                    </Typography>
                    <MenuItem>
                      <Box display="flex" alignItems="center">
                        <Avatar sx={{ bgcolor: "transparent", mr: 1 }}>
                          <MessageIcon color="primary" />
                        </Avatar>
                        <Box>
                          <Typography
                            variant="body1"
                            sx={{
                              fontFamily: "Nunito, sans-serif",
                              fontSize: 13,
                            }}
                          >
                            New user registration
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                              fontFamily: "Nunito, sans-serif",
                              fontSize: 13,
                            }}
                          >
                            2 days ago
                          </Typography>
                        </Box>
                      </Box>
                    </MenuItem>
                    <MenuItem>
                      <Box display="flex" alignItems="center">
                        <Avatar sx={{ bgcolor: "transparent", mr: 1 }}>
                          <MessageIcon color="primary" />
                        </Avatar>
                        <Box>
                          <Typography
                            variant="body1"
                            sx={{
                              fontFamily: "Nunito, sans-serif",
                              fontSize: 13,
                            }}
                          >
                            New user registration
                          </Typography>
                          <Typography
                            variant="body2"
                            color="text.secondary"
                            sx={{
                              fontFamily: "Nunito, sans-serif",
                              fontSize: 13,
                            }}
                          >
                            1 days ago
                          </Typography>
                        </Box>
                      </Box>
                    </MenuItem>
                  </Menu>
                </Grid>
                <Grid size="auto">
                  <Button
                    variant="outlined"
                    size="small"
                    sx={SignOutButton}
                    onClick={handleSignOut}
                  >
                    Sign Out
                  </Button>
                </Grid>
              </Grid>
            </Grid>
          )}
        </Grid>
  );
};

export default Header;
